<template>
  <div id="page-add-emaployer">
    <vs-card>
      <div>
        <div class="vx-row pt-5 px-5">
          <div class="vx-col w-full md:w-1/2 px-8">
            <div class="vx-row mb-2">
              <vs-input
                placeholder="Enter Role Name"
                vs-placeholder="Role Name"
                v-model="form.role_name"
                id="Role Name"
                name="Role Name"
                v-validate="'required|exclude_special_char|min:4'"
                class="mt-3 w-full"
              />
              <span class="text-primary text-sm" v-show="errors.has('Role Name')">{{ errors.first('Role Name') }}</span>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="mt-2 ml-4 flex flex-wrap items-center justify-start">
              <vs-button class="mr-2 vs-con-loading__container" id="update-role" @click="save_changes" type="filled">Update Role</vs-button>
              <vs-button to="/roles-list" color="dark" type="" class="text-gray-500">Cancel</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Edit-Developer',

  // Form Data
  data() {
    return {
      form: {
        role_name: null
      }
    }
  },

  /* Form Validate */
  computed: {
    ...mapState('role', ['loading']),
    validateForm() {
      return !this.errors.any()
    }
  },

  /* API Calling Function */
  methods: {
    ...mapActions('role', {
      updateRole: 'updateRole'
    }),

    async save_changes() {
      try {
        const { message } = await this.updateRole({
          id: this.$route.params.id,
          data: this.form
        })
        this.$router.push({
          name: 'roles-list'
        })
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    }
  },

  /* API Calling Loading */
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#update-role',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#update-role > .con-vs-loading')
      }
    }
  },

  mounted() {
    this.$store
      .dispatch('role/getRoleById', this.$route.params.id)
      .then((res) => {
        const data = res.data
        this.form.role_name = data.role_name
      })
      .catch((err) => {
        const { message } = err
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      })
  }
}
</script>
<style>
.textarea {
  max-height: 100px;
}

.vs-card--content {
  padding: 0;
}
</style>
